/* Ellie's 10/04: keep the cart drawer free-shipping bar in sync.
   The drawer header (where the bar lives) is not re-rendered when items change,
   so a garland added from a product page still showed "$X more for free shipping".
   On every cart update we re-fetch the drawer section and swap in the fresh bar,
   which knows whether the cart holds a garland kit (goal 0 = ships free). */
(function () {
  function markGarland(el) {
    var cfg = (el.getAttribute('data-config') || '').trim();
    var total = Number(el.getAttribute('data-cart-total')) || 0;
    if (cfg === '0' && total > 0) {
      el.classList.remove('hidden');
      el.classList.add('free-shipping-goal--done');
      var bar = el.querySelector('progress-bar');
      if (bar) bar.style.setProperty('--percent', '100%');
    }
  }
  function refresh() {
    var drawer = document.querySelector('cart-drawer[data-section-id]');
    if (!drawer) return;
    var id = drawer.getAttribute('data-section-id');
    var root = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || '/';
    fetch(root + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('free-shipping-goal');
        var current = drawer.querySelector('free-shipping-goal');
        if (fresh && current) {
          current.replaceWith(fresh);
          var live = drawer.querySelector('free-shipping-goal');
          if (live) markGarland(live);
        }
      })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('free-shipping-goal').forEach(markGarland);
  });
})();
